import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faMoneyBill1, faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LikedVacanciesStyled = () => {
  const [likedVacancies, setLikedVacancies] = useState([]);
  const [loading, setLoading] = useState(true);

  const { id } = useParams();
  const { t } = useTranslation();

  const userData = JSON.parse(localStorage.getItem("user"));
  const userId = id || userData?.id;

  useEffect(() => {
    if (!userId) return;

    const fetchLikedVacancies = async () => {
      try {
        const response = await fetch(`/api/get_liked_vacancies.php?user_id=${userId}`);
        const data = await response.json();
        // берем последние 3 вакансии
        setLikedVacancies(data.slice(-3).reverse());
      } catch (error) {
        console.error("Ошибка при загрузке лайкнутых вакансий:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLikedVacancies();
  }, [userId]);

  if (loading) return <p className="text-center py-10 text-gray-500">{t("Loading...")}</p>;
  if (!likedVacancies.length) return <p className="text-center py-10 text-gray-500">{t("NoSavedVacancies")}</p>;

  return (
    <section className="p-0">
      <h1 className="text-4xl mt-3 max-lg:text-xl max-sm:text-sm px-6 font-bold text-white uppercase">
        {t("savevacancies")}
      </h1>

      <section className="grid p-6 max-sm:p-2 grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
        {likedVacancies.map((vacancy) => (
          <article
            key={vacancy.id}
            className="w-full pt-3 overflow-hidden flex-col relative flex justify-start gap-3 items-center rounded-lg shadow-lg bg-white"
          >
            <div className="w-full px-3 flex justify-start items-center gap-6">
              <img
                className="w-[120px] h-[120px] max-md:w-[90px] max-md:h-[90px] rounded-xl border-[3px] border-white bg-gray-200 object-contain"
                src={`/api/uploads/${vacancy.companyLogo}`}
                alt={vacancy.companyName || "Company Logo"}
              />
              <ul className="flex flex-col gap-1 items-start justify-center">
                <li>
                  <Link
                    to={`/vacancy/${vacancy.id}`}
                    className="text-xl max-md:text-[16px] text-[#006674] font-semibold hover:underline"
                  >
                    {vacancy.workname}
                  </Link>
                </li>
                <li className="text-gray-800 text-xl max-md:text-sm">{vacancy.companyName}</li>
                <li className="flex gap-2 items-center text-gray-600 text-md max-sm:text-sm">
                  <FontAwesomeIcon icon={faLocationDot} />
                  {vacancy.workplace}
                </li>
                <li className="flex gap-2 text-md max-sm:text-sm items-center text-gray-600">
                  <FontAwesomeIcon icon={faMoneyBill1} />
                  {vacancy.salary ? `${vacancy.salary} ${vacancy.currency || ""}` : "Չի նշված"}
                </li>
              </ul>
            </div>
            <div className="w-full mt-2 p-2 flex justify-between items-center bg-[#006674] text-white text-sm">
              <span>
                <FontAwesomeIcon className="mr-1" icon={faCalendarAlt} />
                {new Date(vacancy.created_at).toLocaleDateString()}
              </span>
              <Link to={`/vacancy/${vacancy.id}`} className="hover:underline">
              {t("seemore")}
              </Link>
            </div>
          </article>
        ))}
      </section>
    </section>
  );
};

export default LikedVacanciesStyled;
